import Card from "./card.js";
export default class ClassicCard extends Card {
  constructor(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    super(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m),
      (this.At = "ab-classic-card"),
      (this.Tt = !0);
  }
  Bs() {
    const s = {};
    return (
      (s[Card.qt.zt] = Card.Dt.Ei),
      (s[Card.qt.Et] = this.id),
      (s[Card.qt.Ft] = this.viewed),
      (s[Card.qt.Gt] = this.title),
      (s[Card.qt.Jt] = this.imageUrl),
      (s[Card.qt.Kt] = this.description),
      (s[Card.qt.Lt] = this.updated),
      (s[Card.qt.Mt] = this.created),
      (s[Card.qt.Nt] = this.categories),
      (s[Card.qt.Ot] = this.expiresAt),
      (s[Card.qt.URL] = this.url),
      (s[Card.qt.Pt] = this.linkText),
      (s[Card.qt.Qt] = this.aspectRatio),
      (s[Card.qt.St] = this.extras),
      (s[Card.qt.Ut] = this.pinned),
      (s[Card.qt.Vt] = this.dismissible),
      (s[Card.qt.Wt] = this.clicked),
      (s[Card.qt.Xt] = this.test),
      s
    );
  }
}
